import VueI18n from 'vue-i18n'
import { Settings } from 'luxon';

const messages = {
    en: {
        productname: 'Ticket Scan',
        internalerror: 'Internal server error occurred',
        home: {
            appdescription: 'This is a simple app which helps you to control you events.',
            appdescriptionextended: 'It features qr-code scanning and real-time updates of all attendees and just needs to be loaded on your phone.',
        },
        login: {
            login: 'Login',
            username: 'Username',
            usernameinvalid: 'Please enter your username',
            password: 'Password',
            passwordinvalid: 'Please enter your password',
            failed: 'Wrong username or password',
        },
        navigation: {
            events: 'My events',
            logout: 'Logout',
        },
        events: {
            scanticket: 'Scan ticket',
            uploadlist: 'Upload list',
            downloadlist: 'Download list',
            back: 'Back',
            title: 'Title',
            date: 'Date',
            edit: 'Edit',
            delete: 'Delete',
            cancel: 'Cancel',
            save: 'Save',
            nothingselected: 'No event selected',
            addevent: 'Add event',
            scansuccess: 'Attendee with data <strong>{data}</strong> is now attending.',
            scanerror: 'Cannot find attendee with identifier "{id}"',
            scanwarning: 'Attendee with data <strong>{data}</strong> is already attending.',
            continue: 'Continue',
            stopscan: 'Stop scanning',
            search: 'Search...',
        },
    },
    de: {
        productname: 'Ticket Scan',
        home: {
            appdescription: 'Diese einfache App hilft Ihnen Ihre Events zu kontrollieren.',
            appdescriptionextended: 'Es bietet ein qr-code basiertes Scanverfahren was in echtzeit den Status der Teilnehmer auf verschiedene Geräte synchronisiert',
        },
        login: {
            login: 'Einloggen',
            username: 'Benutzername',
            usernameinvalid: 'Bitte geben Sie Ihren Benutzernamen ein',
            password: 'Passwort',
            passwordinvalid: 'Bitte geben Sie Ihr Passwort ein',
            failed: 'Falscher Benutzername oder falsches Password',
        },
        navigation: {
            events: 'Meine Events',
            logout: 'Ausloggen',
        },
        events: {
            scanticket: 'Ticket scannen',
            uploadlist: 'Liste hochladen',
            downloadlist: 'Liste herunterladen',
            back: 'Zurück',
            title: 'Titel',
            date: 'Datum',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            cancel: 'Abbrechen',
            save: 'Speichern',
            nothingselected: 'Kein Event ausgewählt',
            addevent: 'Neues Event',
            scansuccess: 'Der Teilnehmer mit den Daten <strong>{data}</strong> ist jetzt als teilnehmend markiert.',
            scanerror: 'Teilnehmer mit der Id "{id}" konnte nicht gefunden werden',
            scanwarning: 'Der Teilnehmer mit den Daten <strong>{data}</strong> nimmt bereits teil.',
            continue: 'Weiter',
            stopscan: 'Scannen beenden',
            search: 'Suchen...',
        },
    },
};

export function setup(Vue) {
    Vue.use(VueI18n)
    const locale = (localStorage.getItem('locale') || navigator.languages[0] || navigator.language || 'en').substr(0, 2);
    localStorage.setItem('locale', locale);
    const i18n = new VueI18n({
        locale,
        messages,
        fallbackLocale: 'en',
    });
    Settings.defaultLocale = locale;
    return i18n;
}